import React, { useEffect } from "react";
// import RcPicker from "react-mobile-picker";
import RcPicker from "../RcMobilePicker";
import styles from "./index.module.scss";
import scrollLock from "../../utils/scroll-lock";

interface IProps {
  title?: string;
  tipMsg?: string;
  cancelTxt?: string;
  confirmTxt?: string;
  onCancel: () => void;
  onConfirm: (result: object) => void;
  optionGroups: object;
  valueGroups: object;
  onChange?: (name, value) => void;
}

export default function Picker(props: IProps) {
  useEffect(() => {
    scrollLock.enable();

    return () => {
      scrollLock.disable();
    };
  }, []);

  const handleChange = (name, value) => {
    console.log(name, value, "handleChangehandleChange");
    if (!!value) {
      props.onChange && props.onChange(name, value);
    }
  };

  return (
    <div className={styles.pickerModalWrapper}>
      <div
        className={styles.pickerModalMask}
        onClick={() => props.onCancel()}
      ></div>
      <div className={`${styles.pickerModal} ${styles.pickerModalToggle}`}>
        <header>
          <div className={styles.cancelBtn} onClick={() => props.onCancel()}>
            {props.cancelTxt || "取消"}
          </div>
          <div className={styles.title}>{props.title || "请选择"}</div>
          <div className={styles.confirmBtn} onClick={props.onConfirm}>
            {props.confirmTxt || "确定"}
          </div>
        </header>
        {props?.tipMsg ? (
          <div className={styles.tipsContainer}>
            <p className={styles.txt}>{props?.tipMsg}</p>
          </div>
        ) : null}
        <RcPicker
          optionGroups={props.optionGroups}
          valueGroups={props.valueGroups}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}
